import { render, staticRenderFns } from "./areaDetails.vue?vue&type=template&id=08ec01c2&scoped=true&"
import script from "./areaDetails.vue?vue&type=script&lang=js&"
export * from "./areaDetails.vue?vue&type=script&lang=js&"
import style0 from "./areaDetails.vue?vue&type=style&index=0&id=08ec01c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec01c2",
  null
  
)

export default component.exports